export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  USER_DETAIL: (id: string) => `/users/${id}`,
  CATEGORIES: '/categories',
  POSTS: '/content/posts',
  TRENDING_POSTS: '/content/trending',
  POST_DETAIL: (id: string) => `/content/posts/${id}`,
  REPORTED_POSTS: '/content/reported',
  RATINGS: '/ratings',
  TRIBES: '/tribes',
  TRIBE_DETAIL: (id: string) => `/tribes/${id}`,
  MESSAGING: '/messaging',
  REPORTS: '/reports',
  REPORT_DETAIL: (id: string) => `/reports/${id}`,
  NOTIFICATION_TEMPLATES: '/notifications/templates',
  NOTIFICATION_BROADCAST: '/notifications/broadcast',
  NOTIFICATION_LOGS: '/notifications/logs',
  ANALYTICS: '/analytics',
  POLICIES: '/policies',
  POLICY_NEW: '/policies/new',
  POLICY_EDIT: (id: string) => `/policies/${id}/edit`,
  AUDIT_ADMIN: '/audit/admin',
  AUDIT_USER: '/audit/user',
  PROFILE: '/profile',
  SUPPORT: '/support',
  TICKET_DETAIL: (id: string) => `/support/${id}`,
  ADMINS: '/admins',
  ADMIN_DETAIL: (id: string) => `/admins/${id}`,
  ROLES: '/roles',
  ROLE_DETAIL: (id: string) => `/roles/${id}`,
  ONBOARDING: '/onboarding',
  SETTINGS_AGE_CONFIG: '/settings/age-config',
  SETTINGS_COUNTRY_REGION: '/settings/country-region',
  SETTINGS_LOCATION: '/settings/location',
  CONTENT_FILTER_ANALYTICS: '/content/filter-analytics',
  CONTENT_LIKED_PLACES: '/content/liked-places',
  SETTINGS_FEED_RANKING: '/settings/feed-ranking',
  SETTINGS_MAP_DISCOVERY: '/settings/map-discovery',
  SETTINGS_LOCATION_LIKES: '/settings/location-likes',
  SETTINGS_CHECK_IN: '/settings/check-in',
  /** Local-only API testing harness for the four map layers. Never deployed. */
  MAP_LAB: '/map-lab',
  CHALLENGES: '/challenges',
  CHALLENGE_CREATE: '/challenges/create',
  CHALLENGE_DETAIL: (id: string) => `/challenges/${id}`,
  CHALLENGE_EDIT: (id: string) => `/challenges/${id}/edit`,
  CHALLENGE_SUBMISSIONS: (id: string) => `/challenges/${id}/submissions`,
  GPS_LOCATIONS: '/challenges/locations',
  WALLETS: '/challenges/wallet',
  PAYOUTS: '/challenges/payouts',
  TRANSACTIONS: '/challenges/transactions',
  BANK_ACCOUNTS: '/challenges/bank-accounts',
  BANNERS: '/banners',
  REFERRALS: '/referrals',
  REFERRAL_DETAIL: (id: string) => `/referrals/${id}`,
} as const;
